import { Stack } from '@amboss/design-system';

declare type SectionsProps = {
  children: React.ReactNode[] | React.ReactElement;
};

const Sections = ({ children }: SectionsProps) => {
  return <Stack space={'l'}>{children}</Stack>;
};

export default Sections;
